import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Salary Payments is built. Reached from
// Payroll > Disbursement > Salary Payments in the sidebar flyout.
export const DisbursementSalaryPayments = () => <NotImplemented title="Salary Payments" />;
